import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base";
import { LocationsRepository } from "../../repositories";

@Injectable({ providedIn: 'root' })
export class DeleteAllUnAssignedLocationUsecase implements UseCase<string, boolean> {
  constructor(private locationRepository: LocationsRepository) {}

  execute(params: string): Observable<boolean> {
    return this.locationRepository.deleteAllUnAssignedLocation(params);
  }
}